import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import MobileDialog from 'src/components/MobileDialog';
import { useGlobal } from 'src/contexts/GlobalContext';
import { useTheme } from 'src/contexts/ThemeContext';
import { useDeleteSite } from 'src/hooks/api/useSiteEndpoint';
import SettingCard from 'src/pages/Devices/DeviceDetails/TabPages/SensorSettings/components/SettingCard';
import { useAppNavigation } from 'src/routes';

import { DeleteOutlined } from '@ant-design/icons';
import { useModal } from 'src/hooks/useModal';

import { useSiteDetails } from '../../SiteDetailsContext';

export const DeleteSite = () => {
  const { t } = useTranslation();
  const { isDesktop } = useGlobal();
  const { site } = useSiteDetails();
  const { navigateTo } = useAppNavigation();
  const { confirm, contextHolder } = useModal();
  const { combinedTheme } = useTheme();
  const { mutateAsync: deleteSite, isPending: isDeleting } = useDeleteSite(site?.id ?? '');

  const handleMutateRemoveSite = async () => {
    if (site?.id) {
      deleteSite(undefined, {
        onSuccess: navigateTo.sites,
      });
    }
  };

  const handleDeleteSite = () => {
    if (isDesktop) {
      confirm({
        title: t('site.general.deleteSiteModalTitle'),
        content: t('site.general.deleteSiteModalDescription'),
        onOk: async () => await handleMutateRemoveSite(),
      });
    } else {
      return MobileDialog({
        title: t('site.general.deleteSiteModalTitle'),
        description: t('site.general.deleteSiteModalDescription'),
        confirmText: t('general.ok').toUpperCase(),
        cancelText: t('general.cancel'),
        onConfirm: async () => handleMutateRemoveSite(),
        theme: combinedTheme,
      });
    }
  };

  return (
    <div data-testid="delete-site">
      {contextHolder}
      <SettingCard
        title={t('site.general.deleteSite')}
        description={t('site.general.deleteSiteDescription', {
          name: site?.name,
        })}
        items={[
          {
            action: (
              <Button
                disabled={!site?.id}
                type="primary"
                loading={isDeleting}
                danger
                icon={<DeleteOutlined />}
                onClick={handleDeleteSite}
                block={!isDesktop}
              >
                {t('site.general.deleteSite')}
              </Button>
            ),
          },
        ]}
      />
    </div>
  );
};
